import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/site/Landing';
import EEC from '@/components/site/EEC';
import Summit from '@/components/site/Summit';

Vue.use(Router);

export default new Router({
   routes: [
      {
         path: '/',
         name: 'Landing',
         component: Landing
      },   
      {
         path: '/summit',
         name: 'Summit',
         component: Summit
      },
      {
         path: '/eec',
         name: 'EEC',
         component: EEC
      },
      {  
         path: '*', 
         redirect: '/' 
      }
   ],
   mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js